/**
 * The chat's reply when a turn fails, so the failure shows in the
 * conversation instead of only in the console.
 *
 * Two of the server's refusals are written for the user and shown as they
 * are: the daily limit (`resource-exhausted`, functions/features/chat/
 * dailySpend.js) and the assistant being unavailable (`unavailable`,
 * chatFailure.js). Anything else is unexpected, and says so.
 *
 * @param {Error|undefined} error
 * @returns {string}
 */
const WRITTEN_FOR_THE_USER = new Set([
  'functions/resource-exhausted',
  'functions/unavailable',
]);

export const chatErrorMessage = (error) => {
  if (!error?.message) return 'Something went wrong.';
  if (WRITTEN_FOR_THE_USER.has(error.code)) return error.message;
  return `Something went wrong: ${error.message}`;
};
